import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import firebase from "firebase/compat/app";
import "firebase/compat/storage";
import "../styles/AddEmployee.css";
import NavBar from "./Navbar";
import TopNavBar from "./TopNavbar";
import LoaderForm from "./LoaderForm";
import emailIcon from "../images/emailIcon.svg";
import nameIcon from "../images/nameIcon.svg";
import payrateIcon from "../images/payrateIcon.svg";
import DefaultEmployeeProfile from "../images/DefaultEmployeeProfile.svg";
import employeeIdIcon from "../images/employeeIdIcon.svg";
import Select from "react-select";
import axios from "axios";
import { useAuth } from '../auth/auth';
import { PERMISSIONS } from "../utils/rbac";
import { useRoutePermissionGuard } from "../hooks/usePermissionGuard";
const apiUrl = process.env.REACT_APP_API_URL;

const AddEmployee = () => {
  const { allowed: canCreate, PermissionDialog } = useRoutePermissionGuard(
    PERMISSIONS.CREATE_EMPLOYEE,
    "add employee",
  );
  const [image, setImage] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const paymentOptions = [
    { value: "Cheque", label: "Cheque" },
    { value: "Direct Deposit", label: "Direct Deposit" },
    { value: "CashApp", label: "CashApp" },
    { value: "Weekly Bank Transfer", label: "Weekly Bank Transfer" },
  ];

  useAuth();

  const showMessage = (text) => {
    setMessage(text);

    // Hide the message after 2000 milliseconds (2 seconds)
    setTimeout(() => {
      setMessage(null);
    }, 2000);
  };

  const handleKeyDown = (event) => {
    // Allow only numbers, backspace, delete, arrow keys, and decimal point
    const allowedChars = /[0-9\b\t\r\f\v\↓\↑\→\←\.\.]/;
    if (!allowedChars.test(event.key) && event.key !== "Backspace") {
        event.preventDefault();
    }
};
const shouldApplyFilledClass = (value) => {
  return value !== undefined && value !== null && value !== '';
};

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      payRate: "",
      secondaryPayRate: "",
      tertiaryPayRate: "",
      selectedPaymentMethod:"",
      isPayslipEligible: true,
      isInvoiceEligible: true,
    },
    onSubmit: async (values) => {

      if (!values.name) {
        showMessage("Please enter employee Name")
        return;
      }
      if (!values.id) {
        showMessage("Please enter employee Id")
        return;
      }
      // if (!values.email) {
      //   showMessage("Please enter employee email")
      //   return;
      // }
      if (!values.payRate) {
        showMessage("Please enter employee Pay Rate")
        return;
      }

      if (!values.payRate ||  values.payRate == 0) {
        showMessage("Please enter employee Pay Rate")
        return;
      }

      if (!values.selectedPaymentMethod) {
        showMessage("Please select payment method for employee");
        return;
      }

      if (isNaN(values.payRate) || isNaN(values.id)) {
        showMessage("Pay rate and ID must be numbers");
        return;
      }

      // if (!values.secondaryPayRate) {
      //   showMessage("Please enter employee Secondary Pay Rate");
      //   return;
      // }

      // if (isNaN(values.secondaryPayRate)) {
      //   showMessage("Secondary Pay rate must be numbers");
      //   return;
      // }

      setLoading(true);
      try {
        if (image) {
          const timestamp = Date.now(); // Generate a unique timestamp
          const imageName = `${timestamp}_${image.name}`; // Concatenate timestamp with image name

          const storageRef = firebase.storage().ref().child("employees");
          const imageRef = storageRef.child(imageName);
          await imageRef.put(image);
          const imageUrl = await imageRef.getDownloadURL();
          //console.log("imageurl ", imageUrl);
          values.image = imageUrl; // Save the image URL in the form values
        }

        const response = await axios.post(`${apiUrl}/addEmployee`, {
          ...values,
          payment_method: values.selectedPaymentMethod,
        });

        const data = response.data;
        if (response.status >= 200 && response.status < 300) {
          // Show success message in a popup
          //window.alert(data.message);
          showMessage(data.message);
          setTimeout(() => {
            window.location.href = "/manageEmployee";
          }, 1000);
        } else {
          // Show error message in a popup
          //window.alert("Error: " + data.message);
          showMessage("Error: " + data.message);
        }
        
        //console.log("Server response:", data);
        // Handle the response data as needed
      } catch (error) {
        //console.error("Error:", error);
        showMessage("An Error occured");
      }
      finally {
        setLoading(false); 
      }
    },
  });

  const handleImageChange = (e) => {
    if (e.target.files[0]) {
      setImage(e.target.files[0]);
      setImageUrl(URL.createObjectURL(e.target.files[0]));
    }
  };

  return (
    <div className="feedback-parent-container">
      <NavBar />
      <TopNavBar />
      <PermissionDialog />
      <div
        className={`container-addEmployee ${!canCreate ? "pointer-events-none opacity-60" : ""}`}
      >
        <div className="admin-header">
          <div className="left-section">
            <h1 className="admin-header-title">
              <Link
                to="/manageEmployee"
                className="admin-card-title-link custom-link"
              >
                <span className="fade-text">Manage Employee</span>
              </Link>
              {" > "}
              <span className="admin-card-title-span top-heading-add-employee">Add Employee</span>
            </h1>
          </div>
        </div>
        <div className="card-addEmployee">
          <div className="card-body-addEmployee">
            <form
              onSubmit={formik.handleSubmit}
              className="form-container-addEmployee"
            >
              <div className="add-employee-left-section">
                <div className="image-section">
                  <div className="employee-image-container">
                    {!imageUrl && ( // If imageUrl is not available
                      <div className="">
                        <img
                          src={DefaultEmployeeProfile}
                          alt="Default Employee Image"
                        />
                      </div>
                    )}
                    {imageUrl && (
                      <div className="">
                        <img src={imageUrl} alt="Employee Image" />
                      </div>
                    )}
                    <div className="employee-image-container-inside-div">
                      <label htmlFor="imageUpload" className="fileLabel">
                        Choose Image
                      </label>
                      <input
                        id="imageUpload"
                        type="file"
                        accept="image/*"
                        onChange={handleImageChange}
                        style={{ display: "none" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-group-addEmployee form-right-section">
                <div className="input-container-addEmployee input-container-box">
                  <div className="icon-container">
                    <img
                      className="email-icon"
                      src={nameIcon}
                      alt="icon"
                    />
                  </div>
                  <div className="form-input-container">
                    <input
                      type="text"
                      name="name"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      placeholder=""
                      className={formik.values.name ? 'filled' : ''}
                    />
                     <label htmlFor="employeeName">Employee Name</label>
                  </div>
                </div>
                <div className="input-container-addEmployee input-container-box">
                  <div className="icon-container">
                    <img
                      className="email-icon"
                      src={employeeIdIcon}
                      alt="icon"
                    />
                  </div>
                  <div className="form-input-container">
                    <input
                      type="number"
                      pattern="[0-9]*"
                      min="0"
                      name="id"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      onKeyDown={handleKeyDown}
                      placeholder=""
                      //className={formik.values.id ? 'filled' : ''}
                      className={shouldApplyFilledClass(formik.values.id) ? 'filled' : ''}
                    />
                     <label htmlFor="employeeId">Employee ID</label>
                  </div>
                </div>
                <div className="input-container-addEmployee input-container-box">
                  <div className="icon-container">
                    <img
                      className="email-icon"
                      src={emailIcon}
                      alt="icon"
                    />
                  </div>
                  <div className="form-input-container">
                    <input
                      type="email"
                      name="email"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      placeholder=""
                      className={formik.values.email ? 'filled' : ''}
                    />
                    <label htmlFor="emailAddress">Email Address</label>
                  </div>
                </div>
                <div className="input-container-addEmployee input-container-box">
                  <div className="icon-container">
                    <img
                      className="email-icon"
                      src={payrateIcon}
                      alt="icon"
                    />
                  </div>
                  <div className="form-input-container">
                    <input
                      type="text"
                      // pattern="[0-9]*"
                      name="payRate"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      onKeyDown={handleKeyDown}
                      placeholder=""
                     // className={formik.values.payRate ? 'filled' : ''}
                      className={shouldApplyFilledClass(formik.values.payRate) ? 'filled' : ''}
                    />
                    <label htmlFor="payRate">Pay Rate ($/hr)</label>
                  </div>
                </div>
                <div className="input-container-addEmployee input-container-box">
                    <div className="icon-container">
                      <img
                        className="email-icon"
                        src={payrateIcon}
                        alt="icon"
                      />
                    </div>
                    <div className="form-input-container">
                      <input
                        type="number"
                        name="secondaryPayRate"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.secondaryPayRate}
                        placeholder=""
                        className={shouldApplyFilledClass(formik.values.secondaryPayRate) ? 'filled' : ''}
                      />
                       <label htmlFor="secondaryPayRate">Secondary Pay Rate ($/hr)</label>
                    </div>
                  </div>
                  <div className="input-container-addEmployee input-container-box">
                    <div className="icon-container">
                      <img
                        className="email-icon"
                        src={payrateIcon}
                        alt="icon"
                      />
                    </div>
                    <div className="form-input-container">
                      <input
                        type="number"
                        name="tertiaryPayRate"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.tertiaryPayRate}
                        placeholder=""
                        className={shouldApplyFilledClass(formik.values.tertiaryPayRate) ? 'filled' : ''}
                      />
                      <label htmlFor="tertiaryPayRate">Tertiary Pay Rate ($/hr)</label>
                    </div>
                  </div>
                   <div className="input-container-addEmployee input-container-box">
                    <div className="generate-invoice-form-input-container select-type padding-select-type-left">
                                      <Select
                                          placeholder="Select Payment Method"
                                            options={paymentOptions}
                                                value={
                                                  formik.values.selectedPaymentMethod
                                                    ? {
                                                        value: formik.values.selectedPaymentMethod,
                                                        label: formik.values.selectedPaymentMethod,
                                                      }
                                                    : null
                                                }
                                                onChange={(option) => {
                                                  formik.setFieldValue("selectedPaymentMethod", option?.value || "");
                                                }}
                                                isClearable
                                          styles={{
                              menu: (provided) => ({
                                ...provided,
                                maxHeight: "50vh",
                                overflowY: "scroll",
                              }),
                              control: (provided, state) => ({
                                ...provided,
                                width: "30vw",
                                backgroundColor: "#ffff",
                                border: "none",
                                boxShadow: state.isFocused ? "none" : "none",
                                opacity: !(formik.values.payFromDate && formik.values.payToDate) ? 0.5 : 1, // Optional: fade out when disabled
                                cursor: !(formik.values.payFromDate && formik.values.payToDate) ? "not-allowed" : "pointer",
                              }),
                              placeholder: (provided) => ({
                                ...provided,
                                fontFamily: "Montserrat",
                                fontSize: "14px",
                                lineHeight: "21px",
                                fontWeight: 300,
                              }),
                            }}
                               
                                        />
                                </div>
                          </div>       
                          <div className="input-container-addEmployee input-container-box input-container-box--employee-eligibility">
                            <div style={{ display: "flex", gap: "24px", alignItems: "center" }}>
                              <label style={{ display: "flex", alignItems: "center", gap: "8px", fontFamily: "Montserrat" }}>
                                <input
                                  type="checkbox"
                                  name="isPayslipEligible"
                                  checked={!!formik.values.isPayslipEligible}
                                  onChange={(e) =>
                                    formik.setFieldValue("isPayslipEligible", e.target.checked)
                                  }
                                />
                                Payslip Eligible
                              </label>
                              <label style={{ display: "flex", alignItems: "center", gap: "8px", fontFamily: "Montserrat" }}>
                                <input
                                  type="checkbox"
                                  name="isInvoiceEligible"
                                  checked={!!formik.values.isInvoiceEligible}
                                  onChange={(e) =>
                                    formik.setFieldValue("isInvoiceEligible", e.target.checked)
                                  }
                                />
                                Invoice Eligible
                              </label>
                            </div>
                          </div>
                {loading && <LoaderForm />} {/* Show loader if loading is true */}
                  {message && (
                    <div className="custom-modal">
                    <div className="modal-content">
                      {message}
                    </div>
                  </div>
                  )}
                <div className="btn-addEmployee">
                  <button className="add-employee-submit" type="submit">Add Employee</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddEmployee;
